module.exports = __webpack_public_path__ + "img/AuSaturday_Ad2.930287d6.png";